import { render, staticRenderFns } from "./LabelWithSuggestionIcons.vue?vue&type=template&id=89340d82&scoped=true"
import script from "./LabelWithSuggestionIcons.vue?vue&type=script&lang=ts"
export * from "./LabelWithSuggestionIcons.vue?vue&type=script&lang=ts"
import style0 from "./LabelWithSuggestionIcons.vue?vue&type=style&index=0&id=89340d82&prod&lang=scss&scoped=true"
import style1 from "./LabelWithSuggestionIcons.vue?vue&type=style&index=1&id=89340d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89340d82",
  null
  
)

export default component.exports